/**
 * SVG handling class
 *
 * @namespace APP
 * @name APP.Svg
 */

APP.Svg = (/** @lends APP.Svg */function () {
	'use strict';

	var exports,
		$body,
		settings = {
			svgUrl: '{{ASSET_PREFIX}}i/sprite/sprite-app.svg'
		};

	/**
	 * Initialize SVG handling
	 *
	 * @inner
	 * @public
	 * @memberof APP.Svg
	 * @returns {void}
	 */
	function init() {
		initDOMElements();
		loadSvg();
	}

	/**
	 * Init DOM elements
	 *
	 * @inner
	 * @memberof APP.Svg
	 * @returns {jQuery} cached DOM element
	 */
	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	/**
	 * Loads SVG sprite via Ajax<br>
	 * After successful load the SVG structure gets appended to the DOM by [addSpriteToDOM]{@link #APP.SVG.addSpriteToDOM}.
	 *
	 * @inner
	 * @memberof APP.Svg
	 * @returns {void}
	 */
	function loadSvg() {
		var $promise = $.ajax({
			type: 'GET',
			url: settings.svgUrl,
			dataType: 'html',
			contentType: 'application/json; charset=utf-8'
		});

		$.when($promise).then(function (result) {
			addSpriteToDOM(result);
		});
	}

	/**
	 * Add SVG sprite to DOM<br>
	 * The method appends a `div` element with `display: none` style.<br>
	 * If there was an already appended SVG sprite the method replaces it.
	 *
	 * @inner
	 * @memberof APP.Svg
	 * @param {DOM} sprite - the loaded sprite structure
	 * @returns {void}
	 */
	function addSpriteToDOM(sprite) {
		$body.find('[data-svgsprite]').remove();
		$body.append('<div class="block--display-none" data-svgsprite>' + sprite + '</div>');
	}

	exports = {
		init: init
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
